import _default from './Image';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./node_modules/semantic-ui-react/dist/es/elements/Image/index.js
// module id = 62
// module chunks = 0